import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import * as saveAs from "file-saver";


@Injectable({
  providedIn: "root"
})
export class ConsultarPreguntasService {
  constructor(private http: HttpClient) {}

  ConsultarTodasLasPreguntas(NumeroOrdenConflicto) {
    let Data = {
      NumeroOrdenConflicto
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/ConsultarTodasLasPreguntas/`,
      Data
    );
  }

  ConsultarPregunta(Numeropregunta) {
    let Data = {
      Numeropregunta
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/ConsultarPregunta/`,
      Data
    );
  }

  ConsultarRespuestaCorrecta(Numeropregunta) {
    let Data = {
      Numeropregunta
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/consultaRespuestaCorrecta/`,
      Data
    );
  }

  ActualizarPregunta(
    Numeropregunta,
    TituloEspanol,
    SubtituloEspanol,
    DescripcionPreguntaEspanol,
    InstruccionesllenadoEspanol,
    TituloIngles,
    SubtituloIngles,
    DescripcionPreguntaIngles,
    InstruccionesllenadoIngles,
    Texto1ES,
    Texto1EN,
    Texto2ES,
    Texto2EN,
    Texto3ES,
    Texto3EN,
    Texto4ES,
    Texto4EN,
    Texto5ES,
    Texto5EN,
    sideclarasteEspanol,
    sideclarasteIngles,
    respuestaES,
    respuestaEN
  ) {
    let Data = {
      Numeropregunta,
      TituloEspanol,
      SubtituloEspanol,
      DescripcionPreguntaEspanol,
      InstruccionesllenadoEspanol,
      TituloIngles,
      SubtituloIngles,
      DescripcionPreguntaIngles,
      InstruccionesllenadoIngles,
      Texto1ES,
      Texto1EN,
      Texto2ES,
      Texto2EN,
      Texto3ES,
      Texto3EN,
      Texto4ES,
      Texto4EN,
      Texto5ES,
      Texto5EN,
      sideclarasteEspanol,
      sideclarasteIngles,
      respuestaES,
      respuestaEN
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/ActualizarPregunta/`,
      Data
    );
  }

  ActualizarValorConflicto(idcampo, valor) {
    let Data = {
      idcampo,
      valor
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/ActualizarValorConflicto/`,
      Data
    );
  }

  ActualizarValorConflictoCerrado(idcampo, valor) {
    let Data = {
      idcampo,
      valor
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/ActualizarValorConflictoCerrado/`,
      Data
    );
  }

  InsertarValorConflicto(idconflicto, valor) {
    let Data = {
      idconflicto,
      valor
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/InsertarValorConflicto/`,
      Data
    );
  }

  ConsultarConflicto(IdFuncionario, IdConflicto) {
    let Data = {
      IdFuncionario,
      IdConflicto
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/ConsultarConflicto/`,
      Data
    );
  }

  ConsultarConflictoNoExiste(IdFuncionario, IdConflicto,idConflictoRes) {
    let Data = {
      IdFuncionario,
      IdConflicto,
      idConflictoRes,
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/ConsultarConflictoNoExiste/`,
      Data
    );
  }

  ConsultarConflictoResumen(IdFuncionario, IdConflicto) {
    let Data = {
      IdFuncionario,
      IdConflicto
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/ConsultarConflictoResumen/`,
      Data
    );
  }

  ConsultarConflictoResumenAnnio(IdFuncionario, IdConflicto,annio) {
    let Data = {
      IdFuncionario,
      IdConflicto,
      annio,
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/ConsultarConflictoResumenAnnio/`,
      Data
    );
  }

  ConsultarConflictoResumenAnnio2(IdFuncionario, IdConflicto,annio) {
    let Data = {
      IdFuncionario,
      IdConflicto,
      annio,
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/ConsultarConflictoResumenAnnio2/`,
      Data
    );
  }

  consultaPreguntasCantidad(IdFuncionario) {
    console.log("IdFuncionario = ", IdFuncionario)
    return this.http.get(
      `${environment.apiUrl}/Preguntas/consultaPreguntasCantidad/`+IdFuncionario.idtbl_funcionario
    );
  }

  consultaPreguntas() {
   
    return this.http.get(
      `${environment.apiUrl}/Preguntas/consultarPreguntas`
    );
  }


  ConsultarConflictoHistorial(IdFuncionario, IdConflicto,referencia) {
    let Data = {
      IdFuncionario,
      IdConflicto,
      referencia,
      
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/ConsultarConflictoHistorial/`,
      Data
    );
  }

  generarPDF(IdFuncionario, IdConflicto,lenguaje,annio){
    
    let url=`${environment.apiUrl}/Preguntas/resumenPdf/`+IdFuncionario+"/"+IdConflicto+"/"+lenguaje+"/"+annio
    //return this.http.get(url);

    return this.http.get(url, {
      responseType: 'blob' // This must be a Blob type
    })
  }

  generarPDFIndividual(IdFuncionario,IdConflicto,lenguaje,idConflicto,annio,listaActivos?){
    let url
    if(listaActivos.length){
      url=`${environment.apiUrl}/Preguntas/resumenPdfIndividual/`+IdFuncionario+"/"+IdConflicto+"/"+lenguaje+"/"+idConflicto+"/"+annio+"/"+listaActivos.toString()
    }else{
      listaActivos="NO"
      url=`${environment.apiUrl}/Preguntas/resumenPdfIndividual/`+IdFuncionario+"/"+IdConflicto+"/"+lenguaje+"/"+idConflicto+"/"+annio+"/"+listaActivos;
  
    }
    //return this.http.get(url);

    return this.http.get(url, {
      responseType: 'blob' // This must be a Blob type
    })
  }
  
  ConsultaPregunta4(IdFuncionario, IdConflicto) {
    let Data = {
      IdFuncionario,
      IdConflicto
    };
    return this.http.post(
      `${environment.apiUrl}/Preguntas/ConsultaPregunta4/`,
      Data
    );
  }

}
